export default __webpack_public_path__ + "static/media/GUTE_BANKEN_MANUAL.df74ce2d.png";